import { PrimaryDialog, Typography } from "@foodpilot/foods";
import { Stack, useTheme } from "@mui/material";
import { Dispatch, SetStateAction } from "react";
import { useTranslation } from "react-i18next";
import { UserProperty } from "src/context/Property/Builder/PropertyBuilder";
import { DisplayValue } from "./DisplayValue";
import { DisplayGroup } from "./DisplayGroup";
import { DisplayMulti } from "./DisplayMultivalue";

export type ModalData = UserProperty<unknown>;

type PropertyModalProps = {
    isOpen: boolean;
    setOpen: Dispatch<SetStateAction<boolean>>;
    property: ModalData | null;
};
export const PropertyModal = (props: PropertyModalProps) => {
    const { isOpen, setOpen, property } = props;
    const theme = useTheme();
    const { t } = useTranslation();

    if (property === null) return null;

    return (
        <PrimaryDialog
            open={isOpen}
            setOpen={setOpen}
            onValidate={() => {}}
            onCancel={() => {}}
            options={{
                title: (
                    <Stack gap={theme.spacing(1)}>
                        <Typography variant="h4">{property.property.title}</Typography>
                        <Typography variant="body-medium">
                            {t("campaign")} - {property.campaign?.label}
                        </Typography>
                    </Stack>
                ),
                content: <PropertyDisplay property={property} />,
            }}
            cancelText={t("primaryDialog.cancel")}
            validateText={t("primaryDialog.validate")}
        />
    );
};

type PropertyDisplayProps = {
    property: ModalData;
};
const PropertyDisplay = (props: PropertyDisplayProps) => {
    const { property } = props;

    if (property.type === "value") {
        return <DisplayValue property={property} />;
    }

    if (property.type === "group") {
        return <DisplayGroup property={property} />;
    }

    if (property.type === "multi") {
        return <DisplayMulti property={property} />;
    }

    return null;
};
